import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, CircularProgress, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
const StyledModalBody = styled('div')(()=>({
        /** WCAG 1.4.10 */ '@media (max-height: 500px)': {
            overflow: 'unset'
        },
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        height: '100%',
        overflow: 'hidden'
    }));
const StyledModalBodyContents = styled('div')(({ theme })=>({
        /** WCAG 1.4.10 */ '@media (max-height: 500px)': {
            overflowY: 'unset'
        },
        overflowY: 'auto',
        padding: theme.spacing(2.5, 2.5),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2.5, 1.5)
        },
        webkitOverflowScrolling: 'touch'
    }));
const StyledModalLoader = styled('div')({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 300,
    width: '100%'
});
export const ModalBody = (props)=>{
    const translation = useTranslation();
    return /*#__PURE__*/ _jsx(StyledModalBody, {
        children: /*#__PURE__*/ _jsxs(StyledModalBodyContents, {
            "data-component": "modalBody",
            "data-testid": props['data-testid'],
            role: "presentation",
            children: [
                props.isLoading && /*#__PURE__*/ _jsx(StyledModalLoader, {
                    "data-component": "modalLoader",
                    children: /*#__PURE__*/ _jsx(CircularProgress, {})
                }),
                props.isError && /*#__PURE__*/ _jsx(Alert, {
                    "data-component": "modalError",
                    severity: "error",
                    children: translation.t('systemError.apiError')
                }),
                !props.isLoading && !props.isError && props.children
            ]
        })
    });
};
ModalBody.displayName = 'ModalBody';

//# sourceMappingURL=ModalBody.js.map